import {
  _findUserList,
  _findById
} from '@/api/UserM'
import {
  catchErr
} from '@/utils/utils'
import {
  Message
} from 'element-ui'

export default {

  // 获取纪念堂列表
  async findUserList({
    commit,
    state
  }) {

    let paramsAll = {}
    let params = {}

    if (state.userManagement.userSearchForm.date != null && state.userManagement.userSearchForm.date.length >= 2) {
      params.createDateStart = state.userManagement.userSearchForm.date[0];
      params.createDateEnd = state.userManagement.userSearchForm.date[1];
    }
    params.tel = state.userManagement.userSearchForm.tel;
    params.nickname = state.userManagement.userSearchForm.nickname;
    // if (state.userManagement.userSearchForm.source != 0) {
    //   params.source = state.userManagement.userSearchForm.source;
    // }
    // if (state.userManagement.userSearchForm.loginState != 2) {
    //   params.loginState = state.userManagement.userSearchForm.loginState;
    // }
    if (state.userManagement.userSearchForm.telState != 2) {
      params.telState = state.userManagement.userSearchForm.telState;
    }
    if(state.userManagement.userSearchForm.adminEnterpriseMobile != ''){
      params.adminEnterpriseMobile = state.userManagement.userSearchForm.adminEnterpriseMobile
    }
    paramsAll.data = params;
    paramsAll.pageInfo = state.userManagement.pageManagement

    let [err, res] = await catchErr(_findUserList(paramsAll));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      if (res.data == undefined || res.data.length == 0) {
        state.userManagement.number = '0条';
        commit('SETUSERALLIST', [])
      } else {
        state.userManagement.number = res.pageInfo.total + '条';
        res.data.forEach((_t) => {
          if(_t.telState == 1){
            _t.openName = '是'
          }else{
            _t.openName = '否'
          }
          if(_t.serviceAdminEnterpriseMobile != undefined && _t.serviceAdminEnterpriseMobile != ''){

          }else{
            _t.serviceAdminEnterpriseMobile = '—'
          }
          if(_t.tel != undefined && _t.tel != ''){

          }else{
            _t.tel = '—'
          }
          if(_t.nickname != undefined && _t.nickname != ''){

          }else{
            _t.nickname = '—'
          }
          let k = _t.source - 0;
          switch (k) {
            case 1:
              _t.sourceName = '线下';
              break;
            case 2:
              _t.sourceName = 'APP';
              break;
            case 3:
              _t.sourceName = '小程序';
              break;
            default:
          }
          let kt = _t.loginState - 0;
          switch (kt) {
            case 0:
              _t.loginStateName = '否';
              break;
            case 1:
              _t.loginStateName = '是';
              break;
            default:
          }
          let kta = _t.serviceAdminFriend - 0;
          switch (kta) {
            case 0:
              _t.serviceAdminFriendText = '—';
              break;
            case 1:
              _t.serviceAdminFriendText = '是';
              break;
            default:
          }
        });
        commit('SETUSERALLIST', res.data)
      }
      commit('SETPAGEMANAGEMENTUSERALL', res.pageInfo)
    }
    return true;
  },


  // 用户详情
  async findById({
    commit,
    state
  }, params) {
    let [err, res] = await catchErr(_findById({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      return res
    }
    return true;
  },

}



// WEBPACK FOOTER //
// ./src/store/modules/UserManagement/actions.js